import React from 'react';
import pt from 'prop-types';
import { connect } from 'react-redux';
import actions from 'partners/actions';
import NewAppPage from 'partners/components/pages/apps/new';

export const mapStateToProps = (state) => ({});

export const mapDispatchToProps = (dispatch) => ({
  linkApps: (apps) => {
    return dispatch(actions.apps.link(apps));
  },
});

export class NewApp extends React.Component {
  static propTypes = {
    router: pt.object,
    linkApps: pt.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      onLinkApps: this.onLinkApps.bind(this),
    };
  }

  async onLinkApps(apps) {
    const { router, linkApps } = this.props;

    await linkApps(apps);

    router.push('/apps');

    return true;
  }

  render() {
    return <NewAppPage {...this.props} {...this.state} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewApp);
